export const servicesData = [
  {
    category: "General Assessments & Treatments",
    items: [
      {
        title: "Meet & Greet",
        description: ["15-minute Phone Consultation"],
        duration: "15 min",
        price: "$0.00"
      },
      {
        title: "Initial Assessment and Treatment (120 min)",
        description: [
          "A comprehensive evaluation of your body's condition, lifestyle, and health goals.",
          "Physical exams.",
          "Disease diagnosis and health coaching for self-care to improve the treatment’s effects and change your lifestyle",
          "1st acupuncture treatment and/or other modality treatment, which is best suited for your health condition.",
          "Spectral Light therapy with Infrared Crystal therapy."
        ],
        duration: "120 min",
        price: "$250"
      },
      {
        title: "Follow-Up Assessment and Treatment (90 min)",
        description: [
          "A comprehensive follow-up assessment and treatment for ongoing care.",
          "Spectral Light therapy with Infrared Crystal therapy."
        ],
        duration: "90 min",
        price: "$150"
      },
      {
        title: "Follow-Up Assessment and Treatment for Chronic Internal Conditions - 90 minutes (90 min)",
        description: [
          "A comprehensive follow-up assessment and treatment for ongoing care.",
          "Spectral Light therapy with Infrared Crystal therapy.",
          "For disease conditions which indicate special care for additional regular interventions and prescriptions for the treatment."
        ],
        duration: "90 min",
        price: "$180"
      },
      {
        title: "Initial Online Health Consultation & Coaching",
        description: [
          "A comprehensive evaluation of your body’s condition, lifestyle, and health goals.",
          "Disease diagnosis and health coaching for self-care, lifestyle changes, and recommendations for further assessment and treatment procedures."
        ],
        duration: "75 min",
        price: "$180"
      },
      {
        title: "Follow-Up Online Health Consultation & Coaching",
        description: [
          "A focused evaluation of your body’s condition, lifestyle, and health goals.",
          "Disease diagnosis and health coaching for self-care, lifestyle changes, and recommendations for further assessment and treatment procedures."
        ],
        duration: "50 min",
        price: "$120"
      },
    ]
  },
  {
    category: "Facial Rejuvenation Services",
    items: [
      {
        title: "Meet & Greet",
        description: ["15-minute phone consultation"],
        duration: "15 min",
        price: "$0.00"
      },
      {
        title: "Cosmetic Acupuncture Initial",
        description: [
          "First facial rejuvenation acupuncture session.",
          "Includes personalized health assessment and body acupuncture treatment, which is customized based on your fundamental body condition, to enhance the facial rejuvenation treatment effect.",
          "Additional facial Gua Sha/Cupping.",
          "Spectral Light therapy with Infrared Crystal therapy."
        ],
        duration: "120 min",
        price: "$295"
      },
      {
        title: "Cosmetic Acupuncture Follow-Up",
        description: [
          "Regular follow-up assessment and facial acupuncture treatment for ongoing care.",
          "Additional facial Gua Sha/Cupping.",
          "Each session includes an accompanied body acupuncture treatment tailored to your fundamental body condition to enhance the facial rejuvenation treatment.",
          "Spectral Light therapy with Infrared Crystal therapy."
        ],
        duration: "90 min",
        price: "$190"
      }
    ]
  }
];